import * as React from "react";
const AddItemLarge = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 63 63", fill: "currentColor", width: size || "63", height: size || "63", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M31 31V0h1v31h31v1H32v31h-1V32H0v-1z" }));
AddItemLarge.displayName = "AddItemLarge";
var AddItemLarge_default = AddItemLarge;
export {
  AddItemLarge_default as default
};
